import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index/index.vue'
import About from '@/views/about/about.vue'
import Contact from '@/views/contact/contact.vue'
import Product from '@/views/product/product.vue'
import Case from '@/views/case/case.vue'
import Software from '@/views/software/software.vue'
import Solution from '@/views/solution/solution.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
		path: '/',
		name: 'Index',
		component: Index
    },
	{
		path: '/About',
		name: 'About',
		component: About
	},
	{
		path: '/Contact',
		name: 'Contact',
		component: Contact
	},
	{
		path: '/Product',
		name: 'Product',
		component: Product
	},
	{
		path: '/Case',
		name: 'Case',
		component: Case
	},
	{
		path: '/Software',
		name: 'Software',
		component: Software
	},
	{
		path: '/Solution',
		name: 'Solution',
		component: Solution
	}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js